import { render, staticRenderFns } from "./TbProviderAccStatus.vue?vue&type=template&id=6223c208&scoped=true&"
import script from "./TbProviderAccStatus.vue?vue&type=script&lang=js&"
export * from "./TbProviderAccStatus.vue?vue&type=script&lang=js&"
import style0 from "./TbProviderAccStatus.vue?vue&type=style&index=0&id=6223c208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223c208",
  null
  
)

export default component.exports